import React, { useState, useEffect } from 'react'
import * as moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import PdfDocument from './BOLPdfDocument';
import styled from 'styled-components';
import Button from 'web/components/Button';
import DownArrow from 'web/assets/images/downArrow.png';
import CancelOrderPopup from '../CancelOrderPopup';

import BolUploadModal from 'web/components/BolUploadModal';
import { FORMAT} from 'web/components/utils/dateOfBirthValidation';
import ShippingIcon from 'web/assets/svg/ShippingIcon'
import DeliveredIcon from 'web/assets/svg/DeliveredIcon'
import UploadDummy from 'web/assets/images/UploadDummy.png'
import bolDocument from 'web/assets/images/BOL.webp'
import { TrackDetail, DownloadBOL, Panding, TrackBox, TrackDescription, Icon, Msg } from './trackDetailTypeTwoStyled'
import { fetchLanguageContentNew } from 'redux/actions/language';

const TrackDetailTypeTwo = ({ items, callBackFun, resolvedWithExchange, canceledOrderCallBack, rescheduleCallBack, downloadCallBack, orderType, modalCallBack }) => {
    const dispatch = useDispatch();
    const [requestType, setRequestType] = useState()
    const [cancelOrderId, setCancelOrderId] = useState()
    const [cancelOrderModal, setCancelOrderModal] = useState(false);
    const cancelOrderToggleModal = () => setCancelOrderModal(!cancelOrderModal);

    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalLink, setModalLink] = useState('/');
    const toggleModal = () => setModal(!modal);

    const currentLanguage = useSelector(state => state.language.currentLanguage)
    const languageContentNew = useSelector(state => state.language.languageContentNew)
    const [pageLanguageContents, setPageLanguageContents] = useState()
    const [statusArr, setStatusArr] = useState([])

    useEffect(() => {
        if (languageContentNew?.My_Orders_Page) setPageLanguageContents(languageContentNew.My_Orders_Page)
        else dispatch(fetchLanguageContentNew(currentLanguage))
    }, [languageContentNew])

    useEffect(() => {
        setStatusArr([pageLanguageContents?.DetailedContents[13]?.Shipped,
        pageLanguageContents?.DetailedContents[25]?.UploadBOL])
    }, [pageLanguageContents])

    const generatePdfDocument = async (documentData) => {
        const blob = await pdf((
            <PdfDocument
                items={documentData}
            />
        )).toBlob();
        saveAs(blob, documentData.id);
    };
    const downloadPDFTemplate = (items) => {
        return <DownloadBOL
            className="upload"
            onClick={() => {
                generatePdfDocument(items)
            }}
        >
            {/* <img
                style={{ marginRight: "5px" }}
                src={UploadDummy}
                alt="upload Dummy"
            /> */}
            {pageLanguageContents?.DetailedContents[12]?.DownloadBOL}
        </DownloadBOL>
    }
    const orderTabs = (index,items) => {
        return (
            <>
                {index === 0 && orderType !== "deliveable" && (<div className="tracking-details">
                    <ul className="delivery-timeline">
                        
                            <>
                                <li className="ordered">
                                    <div className="d-icon">
                                        <span>
                                            {pageLanguageContents?.DetailedContents[26]?.Order}
                                        </span>
                                    </div>
                                </li>
                                <li
                                    className="shipping pending"
                                    onClick={() => {
                                        callBackFun(items.id, "SHIPPED");
                                    }}
                                >
                                    <img className="down-arrow" src={DownArrow} alt="Pallets" />
                                    <div className="d-icon">
                                        <span>
                                            {pageLanguageContents?.DetailedContents[14]?.Shipping}
                                        </span>
                                        <span className="status">
                                            {pageLanguageContents?.DetailedContents[15]?.Pending}
                                        </span>
                                    </div>
                                </li>
                                <li className="delivered pending">
                                    <div className="d-icon">
                                        <span>
                                            {pageLanguageContents?.DetailedContents[17]?.Delivery}
                                        </span>
                                        <span className="status">
                                            {pageLanguageContents?.DetailedContents[15]?.Pending}
                                        </span>
                                    </div>
                                </li>
                            </>
                        
                    </ul>
                </div>)}
                {/* {index === 0 && items.orderRefNumber && <div className='my-3'>{downloadPDFTemplate(items)}</div>} */}
            </>
        );
    }

    const downloadDocuments = () => {
        window.open(bolDocument);
    }
    const orderShipped = (index) => {
        return (
            <>
                <div className="tracking-details">
                    <ul className="delivery-timeline">
                        <li className="ordered active">
                            <div className="d-icon">
                                <span>ORDER</span>
                            </div>
                        </li>
                        <li className="accepted">
                            <div className="d-icon">
                                <span>
                                    {pageLanguageContents?.DetailedContents[13]?.Shipped}
                                </span>
                            </div>
                        </li>
                        <li
                            className="delivered pending"
                            onClick={() => {
                                toggleModal();
                            }}
                        >
                            <img className="down-arrow" src={DownArrow} alt="Pallets" />
                            <div className="d-icon">
                                <span>
                                    {pageLanguageContents?.DetailedContents[17]?.Delivery}
                                </span>
                                <span className="status">
                                    {pageLanguageContents?.DetailedContents[15]?.Pending}
                                </span>
                            </div>
                        </li>
                    </ul>

                </div>
                {/* {items.orderRefNumber && <div className='my-3'>{downloadPDFTemplate(items)}</div>} */}
            </>
        );
    }
    
    const acceptReject = () => {
        return <>
            {items.rescheduleOrder && items.rescheduleOrder.requestedUserType !== items.userType ? (
                <TrackDescription>
                    <TrackDetail>
                        <TrackBox>
                            {items.rescheduleOrder.requestedUserType === "BUYER" ?
                                <Msg>{items.buyerInfo.companyName} {pageLanguageContents?.DetailedContents[18]?.Alert3} {moment(items.rescheduleOrder.buyerRescheduledDate).format(FORMAT)}?</Msg>
                                : <Msg>{items.sellerInfo.companyName} {pageLanguageContents?.DetailedContents[18]?.Alert3} {moment(items.rescheduleOrder.sellerRescheduledDate).format(FORMAT)}?</Msg>
                            }

                            <TrackDescription>
                                <Button
                                    type='app-green-button'
                                    handleClick={() => {
                                        rescheduleCallBack(items.id, "ACCEPTED")
                                    }}>
                                    {pageLanguageContents?.DetailedContents[19]?.Accept}
                                </Button>
                                <Button
                                    type='app-green-button'
                                    handleClick={() => {
                                        if (items.orderDetails.postType === "INVENTORY" && items.rescheduleOrder && items.rescheduleOrder.requestedUserType === "SELLER" && items.userType === "SELLER") {
                                            setCancelOrderId(items.id)
                                            setRequestType("REJECTED")
                                            cancelOrderToggleModal()
                                        } if (items.orderDetails.postType === "POSTLOAD" && items.rescheduleOrder && items.rescheduleOrder.requestedUserType === "BUYER" && items.userType === "BUYER") {
                                            setCancelOrderId(items.id)
                                            setRequestType("REJECTED")
                                            cancelOrderToggleModal()
                                        } else {
                                            rescheduleCallBack(items.id, "REJECTED")
                                        }
                                    }}>
                                    {pageLanguageContents?.DetailedContents[20]?.Reject}
                                </Button>
                            </TrackDescription>
                        </TrackBox>
                    </TrackDetail>
                </TrackDescription>) : <TrackBox><Msg>{pageLanguageContents?.DetailedContents[21]?.Alert4}</Msg> </TrackBox>
            }</>
    }

    const shippedDelivered = () => {
        return <>
            {items.shippingStatusDetails && items.shippingStatusDetails.length !== 0 ?
                (<>{statusArr.map((shippingItems, index) => (
                    <>{items.shippingStatusDetails[index] ? <>
                        <>{statusArr[index] === items.shippingStatusDetails[index].shippingStatus && items.shippingStatusDetails[index].set === true ?
                            <div className='active'>
                                {orderShipped(index)}
                                <p style={{textAlign: 'center'}}>{moment(items.shippingStatusDetails[index].createdSellerTime).format("hh:mm A")}, {moment(items.shippingStatusDetails[index].createdSellerTime).format(FORMAT)}</p>
                                {/* {items.orderRefNumber && <div className='my-3' style={{"float": "right"}}>{downloadPDFTemplate(items)}</div>} */}
                            </div> : <>{orderTabs(index,items)}</>}</>
                    </> : orderTabs(index,items)}</>
                ))}
                </>
                ) : <>{statusArr.map((itemsVal, index) => (orderTabs(index,items)))}</>
            }
        </>
    }
    return (<>
        <TrackDetail>
            {items.orderStatus === "RESCHEDULED" &&
                acceptReject()
            }

            {items.orderStatus === "ASSIGNED" && !items.rescheduleOrder &&
                <TrackBox>
                    {items.userType === "SELLER" && items.sellerCancelledTimeLeft !== 0 &&
                        <> <p>
                        </p>
                        </>
                    }

                    {items.userType !== "SELLER" && items.buyerCancelledTimeLeft !== 0 && <> <p>
                    </p>
                    </>
                    }
                    {shippedDelivered()}
                </TrackBox>
            }

            {items.orderStatus === "SHIPPED" &&
                <TrackBox>
                    {items.userType === "SELLER" && items.sellerCancelledTimeLeft !== 0 &&
                        <><p>
                        </p>
                        </>
                    }

                    {items.userType !== "SELLER" && items.buyerCancelledTimeLeft !== 0 && <> <p>
                    </p>
                    </>
                    }

                    {shippedDelivered()}
                </TrackBox>
            }
            {items.orderStatus === "ASSIGNED" && items.rescheduleOrder && (items.rescheduleOrder.rescheduleOrderStatus === "ACCEPTED" || items.rescheduleOrder.rescheduleOrderStatus === "PENDING") &&
                <TrackBox>
                    {!items.isClaimed && items.rescheduleOrder?.rescheduleOrderStatus !== "PENDING" && !resolvedWithExchange &&
                        <>
                        <Msg>{pageLanguageContents?.DetailedContents[22]?.Alert5}</Msg>
                            <div className="mx-0 px-3">
                                <p>
                                {/* <span className="bold">{pageLanguageContents?.DetailedContents[23]?.RescheduledDeliveryDate} </span> {items.contactInfo.requestedDate === null ? <span>NA</span> : <span>{moment(items.rescheduleOrder && items.rescheduleOrder.buyerRescheduledDate).format(FORMAT)}</span>} */}
                                </p>
                            </div>
                        </>
                    }
                    {shippedDelivered()}
                    
                </TrackBox>
                
            }
             {/* {items.orderRefNumber && <div className='my-3'>{downloadPDFTemplate(items)}</div>} */}
        </TrackDetail>
        {cancelOrderId && <CancelOrderPopup
            isOpen={cancelOrderModal}
            toggle={cancelOrderToggleModal}
            title=''
            onClickHander={(obj) => {
            }}
            content=''
            link='/'
            cancelOrderId={cancelOrderId}
            items={items}
            requestType={requestType}
            modalCallBackFun={(id, action, props) => {
                modalCallBack(id, action, props)
            }}
        />}

        <BolUploadModal
            isOpen={modal}
            toggle={toggleModal}
            title=''
            content=''
            link='/'
            callBackBOL={(document) => {
                callBackFun(items.id, "DELIVERED", document);
            }}
            uploadType='Upload'
            selectedItem={items}
        />
    </>
    )
};

export default TrackDetailTypeTwo;

const TrackStatus = styled.div`
    font-size: 15px;
    font-weight:bold;
    flex: unset !important;
`